import { Component, Input } from '@angular/core';

import { ResearchInfrastructureEmployment } from 'app/fs/res/research-infrastructure/model/research-infrastructure-classes';

@Component( {
    selector: 'res-research-infrastructure-edit-employment-additional-data',
    templateUrl: './research-infrastructure-edit-employment-additional-data.component.html',
} )
export class ResearchInfrastructureEditEmploymentAdditionalDataComponent {
    @Input() researchInfrastructureEmployment: ResearchInfrastructureEmployment;

    get maxDateValidTo() {
        return this.researchInfrastructureEmployment.validTo != null ? this.researchInfrastructureEmployment.validTo as Date : null;
    }

    get maxDateValidFrom() {
        return this.researchInfrastructureEmployment.validFrom != null ? this.researchInfrastructureEmployment.validFrom as Date : null;
    }

}
